// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__5a4zn"};